import { render } from "./GameSummary.vue?vue&type=template&id=71c6a6e5"
import script from "./GameSummary.vue?vue&type=script&lang=js"
export * from "./GameSummary.vue?vue&type=script&lang=js"

import "./GameSummary.vue?vue&type=style&index=0&id=71c6a6e5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__